module.exports = "https://static.wmbcdn.com/uniweb/images/b8ff82375f68d7f4d989751983254017.svg";